import { useState, useEffect } from "react"

const useResponsiveVisible = () => {
  const [isResponsiveVisible, setIsResponsiveVisible] = useState(false)

  useEffect(() => {
    let timeoutId

    const checkWidth = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        setIsResponsiveVisible(window.innerWidth < 576)
      }, 100)
    }

    window.addEventListener("resize", checkWidth)
    checkWidth()

    return () => {
      window.removeEventListener("resize", checkWidth)
      clearTimeout(timeoutId)
    }
  }, [])

  return isResponsiveVisible
}
export default useResponsiveVisible
